import { useState } from "react";

export function usePlatosUI() {
    const [q, setQ] = useState("");
    const [openPlatos, setOpenPlatos] = useState(new Set());

    const togglePlato = (id) => {
        setOpenPlatos((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    const isPlatoOpen = (id) => openPlatos.has(id);

    // delete modal
    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    return {
        q, setQ,
        togglePlato, isPlatoOpen,
        showConfirm, setShowConfirm,
        deleteId, setDeleteId,
    };
}
